"use client";
import React from "react";
import Link from "next/link";
import {usePathname} from "next/navigation";
import Image, {StaticImageData} from "next/image";
import {useTextVariants} from "@/theme/components/useSectionHeading";
import {AspectRatio, HStack, Text, Wrap, WrapItem} from "@chakra-ui/react";

export type PageProps = {
  image: StaticImageData;
  label: string;
  href: string;
};

const PagesTabs = ({props}: {props: PageProps[]}) => {
  const pathname = usePathname();
  const TextVariant = useTextVariants();
  return (
    <Wrap
      spacing={4}
      align={"center"}
      justify={"center"}
      display={{base: "none", sm: "block"}}
    >
      {props.map((data, index) => {
        const isActive = pathname === data.href;
        return (
          <WrapItem as={Link} key={index} href={data.href} borderRadius={"20px"}>
            <HStack
              borderWidth={"1px"}
              borderRadius={"20px"}
              bg={isActive ? "blue.100" : "transparent"}
              borderColor={isActive ? "black" : "gray.300"}
              _hover={{
                bg: isActive ? "" : "gray.100",
              }}
              className="brand-shadow"
              p={"16px"}
              spacing={2}
            >
              <AspectRatio ratio={1} position={"relative"} w={"24px"}>
                <Image
                  alt="image tab"
                  src={data.image}
                  fill
                  style={{objectFit: "contain", objectPosition: "center"}}
                />
              </AspectRatio>
              <Text
                fontWeight={600}
                variant={TextVariant}
                color={isActive ? "blue.500" : "black"}
              >
                {data.label}
              </Text>
            </HStack>
          </WrapItem>
        );
      })}
    </Wrap>
  );
};

export default PagesTabs;
